(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["product-garment-options"] && !Shopify.designMode) return;
  try {
    class GarmentOptions extends HTMLElement {
    connectedCallback() {
      this.fit = this.querySelector('[ref="fit"]');
      this.size = this.querySelector('[ref="size"]');
      this.colour = this.querySelector('[ref="colour"]');
      this.note = this.querySelector('[ref="restrictedNote"]');
      if (!this.fit || !this.size || !this.colour) return;

      try {
        this.sizeMap = JSON.parse(this.dataset.sizes || '{}');
      } catch (e) {
        this.sizeMap = {};
      }
      this.restrictedSizes = this.splitList(this.dataset.restrictedSizes);
      this.restrictedColours = this.splitList(this.dataset.restrictedColours);
      this.sizePlaceholder = this.dataset.sizePlaceholder || '';

      this.fit.addEventListener('change', () => this.onFitChange());
      this.size.addEventListener('change', () => this.applyColourRestriction());
      this.onFitChange();
    }

    splitList(v) {
      return (v || '')
        .split(',')
        .map((s) => s.trim())
        .filter(Boolean);
    }

    /* Fit decides which sizes exist at all — Women has no 3XL, Kids is sized in cm.
       Entries are [value, label]: the value is submitted, the label is shown. */
    onFitChange() {
      const sizes = this.sizeMap[this.fit.value] || [];
      const previous = this.size.value;
      this.size.innerHTML = '';

      const placeholder = document.createElement('option');
      placeholder.value = '';
      placeholder.textContent = this.sizePlaceholder;
      this.size.appendChild(placeholder);

      sizes.forEach((pair) => {
        const [value, label] = Array.isArray(pair) ? pair : [pair, pair];
        const o = document.createElement('option');
        o.value = value;
        o.textContent = label;
        this.size.appendChild(o);
      });

      this.size.disabled = sizes.length === 0;
      if (sizes.some((p) => (Array.isArray(p) ? p[0] : p) === previous)) {
        this.size.value = previous;
      }
      this.applyColourRestriction();
    }

    /* Large sizes are only printed on certain garment colours. Rather than let a
       customer submit an impossible combination, narrow the colour list and say why.
       Matching is on canonical values, so it is unaffected by translation. */
    applyColourRestriction() {
      const restricted = this.restrictedSizes.includes(this.size.value);
      const allowed = this.restrictedColours;

      Array.from(this.colour.options).forEach((o) => {
        if (!o.value) return;
        o.disabled = restricted && !allowed.includes(o.value);
      });

      if (restricted && this.colour.value && !allowed.includes(this.colour.value)) {
        this.colour.value = '';
      }

      if (this.note) {
        if (restricted && this.dataset.restrictedNote) {
          this.note.textContent = this.dataset.restrictedNote;
          this.note.hidden = false;
        } else {
          this.note.hidden = true;
        }
      }
    }
  }

  if (!customElements.get('garment-options')) {
    customElements.define('garment-options', GarmentOptions);
  }
  } catch(e) { console.error(e); }
})();

})();
